<template>
    <div class="transfer-container">
        <div class="transfer-content">
            <p class="title">{{transferBoxTitle}}</p>
            <i @click="close" class="close"></i>
            <div class="search">
                <span>看板名称：</span>
                <div class="input">
                    <input v-model="title" maxlength="20" placeholder="不超过20个字" type="text">
                    <p>{{title.length}}/20</p>
                </div>
            </div>
            <div class="switch">
                <span>消息提醒：</span>
                <div @click="isSwitch = !isSwitch" :class="{un: isSwitch}">
                  <i></i>
                </div>
            </div>

            <div class="transferBox">
                <div class="left">
                    <div class="title">
                        <div class="left">
                            <i @click="leftSelectAll = !leftSelectAll" :class="{all: leftSelectedNum == mediaList.length, select: leftSelectedNum > 0 && leftSelectedNum < mediaList.length}"></i>
                            <span>检索结果</span>
                        </div>
                        <div class="right">{{leftSelectedNum}}/{{mediaList.length}}</div>
                    </div>
                    <ul>
                        <li :class="{on: item.selected}" v-for="item in mediaList" :key="item.id" @click="item.selected = !item.selected" :title="item.client_name">{{item.client_name}}</li>
                    </ul>
                </div>
                <div class="center">
                    <i @click="toLeft" class="arrow left"></i>
                    <i @click="toRight" class="arrow right"></i>
                    <i @click="clearAll" class="del"></i>
                </div>
                <div class="right">
                    <div class="title">
                        <div class="left">
                            <i @click="rightSelectAll = !rightSelectAll" :class="{all: rightSelectedNum > 0 && rightSelectedNum == selectedList.length, select: rightSelectedNum > 0 && rightSelectedNum < selectedList.length}"></i>
                            <span>已选媒体</span>
                        </div>
                        <div class="right">{{rightSelectedNum}}/{{selectedList.length}}</div>
                    </div>
                    <ul>
                        <li :class="{on: item.selected}" v-for="item in selectedList" :key="item.id" @click="item.selected = !item.selected" :title="item.client_name">{{item.client_name}}</li>
                    </ul>
                </div>
            </div>

            <div class="btns">
                <p @click="submit">确定</p>
                <p @click="close">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        transferBoxTitle: {
            type: String
        },
        config: {
            type: Object
        },
        mediaList: {
            type: Array
        }
    },
    watch: {
        leftSelectAll(to) {
            if(to){
                let mediaList = this.mediaList
                mediaList.forEach(item => {
                    item.selected = true
                })
                this.mediaList = mediaList
            }else{
                let mediaList = this.mediaList
                mediaList.forEach(item => {
                    item.selected = false
                })
                this.mediaList = mediaList
            }
        },
        rightSelectAll(to) {
            if(to){
                let selectedList = this.selectedList
                this.selectedList.forEach(item => {
                    item.selected = true
                })
                this.selectedList = selectedList
            }else{
                let selectedList = this.selectedList
                this.selectedList.forEach(item => {
                    item.selected = false
                })
                this.selectedList = selectedList
            }
        },
        mediaList: {
            deep: true,
            handler: function(n, o) {
                let leftSelectedNum = 0
                this.mediaList.forEach(item => {
                    if(item.selected){
                        leftSelectedNum ++
                    }
                })
                this.leftSelectedNum = leftSelectedNum
            }
        },
        selectedList: {
            deep: true,
            handler: function(n, o) {
                let rightSelectedNum = 0
                this.selectedList.forEach(item => {
                    if(item.selected){
                        rightSelectedNum ++
                    }
                })
                this.rightSelectedNum = rightSelectedNum
            }
        },
        config(to) {
            if(this.config.id){
                this.isSwitch = this.config.need_push == 1 ? false : true
                this.selectedList = this.config.clients
                this.title = this.config.title
            }
        }
    },
    data() {
        return {
            leftSelectAll: false,
            rightSelectAll: false,
            isSwitch: false,
            keyWord: null,
            selectedList: [],
            leftSelectedNum: 0,
            rightSelectedNum: 0,
            title: ''
        }
    },
    methods: {
        submit() {
            let client_id = []
            this.selectedList.forEach(item => {
                client_id.push(item.client_id)
            })
            let info = {
                client_id: client_id.join(','),
                need_push: this.isSwitch ? 0 : 1,
                title: this.title,
                id: this.config.id || ''
            }
            this.$emit('submit', info)
        },
        uniqObjInArray(objarray){
            let res = objarray;
            let obj = {};

            res = res.reduce((cur,next) => {
                obj[next.client_id] ? "" : obj[next.client_id] = true && cur.push(next);
                return cur;
            },[])
            
            return res;
        },
        toLeft() {
            // console.log(this.selectedList)
            // return false;
            let arr = []
            this.selectedList.forEach(item => {
                if(item.selected){
                    arr.push(item.client_id)
                }
            })
            if(arr.length > 0){
                let selectedList = JSON.parse(JSON.stringify(this.selectedList))

                for (let index = 0; index < arr.length; index++) {
                    let client_id = arr[index];
                    selectedList = selectedList.filter(item => {
                        return item.client_id != client_id
                    })
                }

                this.selectedList = JSON.parse(JSON.stringify(selectedList))
            }
        },
        toRight() {
            let selectedList = this.selectedList
            this.mediaList.forEach(item => {
                if(item.selected){
                    selectedList.push({
                        client_name: item.client_name,
                        client_id: item.client_id,
                        selected: false
                    })
                }
            })
            selectedList = this.uniqObjInArray(selectedList)
            this.selectedList = JSON.parse(JSON.stringify(selectedList))
        },
        close() {
            this.$emit('close')
        },
        clearAll() {
            this.selectedList = []
        }
    },
    mounted() {
        if(this.config.id){
            this.isSwitch = this.config.need_push == 1 ? false : true
            this.selectedList = this.config.clients
            this.title = this.config.title
        }
    }
}
</script>

<style lang="less" scoped>
    .transfer-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        background: rgba(50, 59, 75, 0.3); 
        backdrop-filter: blur(1.6px);

        .transfer-content {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 660px;
            height: 560px;
            background: #F9F9F9;
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 33px;
                color: #323B4B;
                font-weight: bold;
                margin-bottom: 10px;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/delIcon.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            .search {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 19px;

                &>span {
                    position: relative;
                    font-size: 14px;
                    line-height: 20px;
                    color: #829191;
                    font-weight: bold;
                    margin-right: 10px;

                    &::before {
                        position: absolute;
                        top: 0;
                        left: -14px;
                        display: inline-block;
                        content: '*';
                        font-size: 20px;
                        color: #FF555A;
                    }
                }

                .input {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex: 1;
                    height: 40px;
                    padding: 0 20px;
                    background: rgba(185, 195, 195, 0.2);
                    border-radius: 20px;
                    box-sizing: border-box;

                    input {
                        flex: 1;
                        height: 100%;
                        background: transparent;

                        &::placeholder {
                            color: #B9C3C3;
                        }
                    }

                    p {
                        font-size: 12px;
                        line-height: 17px;
                        color: #829191;
                    }
                }
            }

            .switch {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 29px;

                span {
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: bold;
                    color: #829191;
                }

                div {
                    display: flex;
                    align-items: center;
                    width: 44px;
                    height: 22px;
                    background: #41B48C;
                    border-radius: 11px;
                    margin-left: 10px;
                    user-select: none;
                    cursor: pointer;

                    &.un {
                        background: #CED3D7;

                        i {
                            margin-left: 2px;
                            transition: margin-left 0.3s;
                        }
                    }

                    i {
                        display: block;
                        width: 18px;
                        height: 18px;
                        background: #FFFFFF;
                        border-radius: 50%;
                        margin-left: 24px;
                        transition: margin-left 0.3s;
                    }
                }
            }

            .transferBox {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width: 100%;
                height: 299px;

                &>.left {
                    width: 280px;
                    height: 299px;
                    background: rgba(185, 195, 195, 0.15);
                    border-radius: 4px;
                    overflow: hidden;

                    .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 280px;
                        height: 42px;
                        background: #D5DEDB;
                        padding: 0 16px;
                        box-sizing: border-box;

                        .left {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            i {
                                position: relative;
                                display: block;
                                width: 16px;
                                height: 16px;
                                border-radius: 8px;
                                border: 1px solid #B9C3C3;
                                box-sizing: border-box;
                                margin-right: 8px;

                                &.all {
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &::after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -6px;
                                        margin-top: -4px;
                                        display: block;
                                        content: '';
                                        width: 12px;
                                        height: 9px;
                                        background: url('./assets/passIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                &.select {
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &::after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -4px;
                                        margin-top: -1px;
                                        display: block;
                                        content: '';
                                        width: 8px;
                                        height: 2px;
                                        background: url('./assets/waitIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            span {
                                font-size: 13px;
                                line-height: 18px;
                                color: #323B4B;
                                font-weight: 500;
                            }
                        }

                        .right {
                            font-size: 12px;
                            line-height: 17px;
                            color: #829191;
                            font-weight: 500;
                        }
                    }

                    ul {
                        width: 100%;
                        height: 257px;
                        overflow-y: auto;

                        &::-webkit-scrollbar {
                            width: 6px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background: rgba(185,195,195,0.5);
                            border-radius: 2px;
                        }

                        li {
                            width: 100%;
                            height: 42px;
                            padding: 0 16px;
                            box-sizing: border-box;
                            font-size: 13px;
                            line-height: 42px;
                            color: #323B4B;                       
                            font-weight: 500;
                            user-select: none;
                            overflow: hidden; 
                            white-space: nowrap; 
                            text-overflow: ellipsis;
                            cursor: pointer;

                            &.on {
                                background: rgba(185, 195, 195, 0.15);
                            }

                            &:hover {                     
                                background: rgba(185, 195, 195, 0.15);
                            }
                        }
                    }
                }

                .center {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    
                    .left {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('./assets/arrow.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        transform: rotate(180deg);
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            background: url('./assets/arrowOn.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            transform: rotate(0);
                        }
                    }

                    .right {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('./assets/arrow.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-top: 8px;
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            background: url('./assets/arrowOn.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            transform: rotate(180deg);
                        }
                    }

                    .del {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('./assets/delBin.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-top: 16px;
                        user-select: none;
                        cursor: pointer;
                    }
                }

                &>.right {
                    width: 280px;
                    height: 299px;
                    background: rgba(185, 195, 195, 0.15);
                    border-radius: 4px;
                    overflow: hidden;

                    .title {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 280px;
                        height: 42px;
                        background: #D5DEDB;
                        padding: 0 16px;
                        box-sizing: border-box;

                        .left {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            i {
                                position: relative;
                                display: block;
                                width: 16px;
                                height: 16px;
                                border-radius: 8px;
                                border: 1px solid #B9C3C3;
                                box-sizing: border-box;
                                margin-right: 8px;

                                &.all {
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &::after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -6px;
                                        margin-top: -4px;
                                        display: block;
                                        content: '';
                                        width: 12px;
                                        height: 9px;
                                        background: url('./assets/passIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                &.select {
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &::after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -4px;
                                        margin-top: -1px;
                                        display: block;
                                        content: '';
                                        width: 8px;
                                        height: 2px;
                                        background: url('./assets/waitIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }

                            span {
                                font-size: 13px;
                                line-height: 18px;
                                color: #323B4B;
                                font-weight: 500;
                            }
                        }

                        .right {
                            font-size: 12px;
                            line-height: 17px;
                            color: #829191;
                            font-weight: 500;
                        }
                    }

                    ul {
                        width: 100%;
                        height: 257px;
                        overflow-y: auto;

                        &::-webkit-scrollbar {
                            width: 6px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background: rgba(185,195,195,0.5);
                            border-radius: 2px;
                        }

                        li {
                            width: 100%;
                            height: 42px;
                            padding: 0 16px;
                            box-sizing: border-box;
                            font-size: 13px;
                            line-height: 42px;
                            color: #323B4B;                       
                            font-weight: 500;
                            user-select: none;
                            cursor: pointer;
                            overflow: hidden; 
                            white-space: nowrap; 
                            text-overflow: ellipsis;

                            &.on {
                                background: rgba(185, 195, 195, 0.15)
                            }

                            &:hover {                     
                                background: rgba(185, 195, 195, 0.15);
                            }
                        }
                    }
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-top: 24px;

                p {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 40px;
                    border-radius: 25px;
                    border: 1px solid #41B48C;
                    font-size: 14px;
                    color: #41B48C;
                    user-select: none;
                    cursor: pointer;

                    &:nth-last-of-type(1) {
                        margin-left: 20px;
                    }

                    &:nth-of-type(1) {
                        background: #41B48C;
                        color: #FFF;
                    }
                }
            }
        }
    }
</style>